module.exports = __webpack_public_path__ + "assets/a.b811a85b.svg";